import SignoutCallback from "./signout-callback";
export default SignoutCallback;
